import { UserDTO } from "./user";

export enum EventType {
  LOGIN = 0,
  LOGOUT = 1,
  FEEDBACK_VIEWED = 2,
  FEEDBACK_REPLIED = 3,
  FEEDBACK_CREATED = 4,
  FEEDBACK_DELETED = 5,
  FEEDBACK_ATTACHMENTS_ADDED = 6,
  FEEDBACK_ATTACHMENTS_REMOVED = 7,
  PLANOGRAM_VIEWED = 8,
  PLANOGRAM_SAVED = 9,
  FEEDBACK_COMPLETED = 10,
  PLANOGRAM_APPROVED = 11
}

export interface EventDTO {
  id: string;
  user: UserDTO;
  planogramId?: string;
  planogramName?: string;
  eventType: EventType;
  eventName: string;
  description: string;
  metadata?: string;
  dateCreated: string;
}